import { useCallback, useEffect, useRef, useState } from 'react';

export interface ToastMessage {
  text: string;
  kind: 'ok' | 'error';
}

const VISIBLE_MS = 4200;

export function useToast() {
  const [toast, setToast] = useState<ToastMessage | null>(null);
  const timer = useRef<number | undefined>(undefined);

  const show = useCallback((text: string, kind: ToastMessage['kind'] = 'ok') => {
    window.clearTimeout(timer.current);
    setToast({ text, kind });
    timer.current = window.setTimeout(() => setToast(null), VISIBLE_MS);
  }, []);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  return { toast, show };
}

/** Aviso flutuante no rodapé, como no design. */
export function Toast({ message }: { message: ToastMessage | null }) {
  if (!message) return null;

  return (
    <div
      role="status"
      className={`animate-rise fixed bottom-[calc(84px+env(safe-area-inset-bottom))] left-1/2 z-50 max-w-[min(420px,calc(100vw-32px))] -translate-x-1/2 rounded-xl px-4 py-3 text-[13px] font-bold text-white shadow-[0_10px_30px_rgb(10_20_45/0.25)] ${
        message.kind === 'error' ? 'bg-danger-600' : 'bg-navy-950'
      }`}
    >
      {message.text}
    </div>
  );
}
